import { gql } from "@apollo/client";

export const MARK_AS_NOT_RENEWABLE = gql`
  mutation markAsNotRenewable($input: MarkAsNotRenewableInput!) {
    markAsNotRenewable(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const GENERATE_RENEWAL_OFFERS = gql`
  mutation generateRenewalOffers($input: GenerateRenewalOffersInput!) {
    generateRenewalOffers(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const MARK_AWAITING_CLIENT_RESPONSE = gql`
  mutation markAwaitingClientResponse($input: MarkAwaitingClientResponseInput!) {
    markAwaitingClientResponse(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const RECOMPUTE_RENEWAL_QUOTATIONS = gql`
  mutation recomputeRenewalQuotations($input: RecomputeRenewalQuotationsInput!) {
    recomputeRenewalQuotations(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const UPDATE_RENEWAL_INSURANCE_QUOTATIONS = gql`
  mutation updateRenewalInsuranceQuotations($input: UpdateRenewalInsuranceQuotationsInput!) {
    updateRenewalInsuranceQuotations(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const UPDATE_INSURANCE_DOCUMENT_COMMENTS = gql`
  mutation updateInsuranceDocumentComments($input: UpdateInsuranceDocumentCommentsInput!) {
    updateInsuranceDocumentComments(input: $input) {
      commandId
      correlationId
    }
  }
`;
